import { useState, useEffect, useCallback } from 'react';
import { useNotifications } from '../../../hooks/useNotifications';
import { WorkStationRecordsService } from '../../../services/workStationRecordsService';

const useWorkStationCheckin = () => {
  const [lastRecord, setLastRecord] = useState(null);
  const [isLoadingLastRecord, setIsLoadingLastRecord] = useState(true);
  const [isCreating, setIsCreating] = useState(false);
  const { showErrorNotification } = useNotifications();

  useEffect(() => {
    const fetchLastRecord = async () => {
      setIsLoadingLastRecord(true);
      try {
        const { workStationRecord } = await WorkStationRecordsService.getLastRecord();
        setLastRecord(workStationRecord);
      } catch {
        showErrorNotification({ title: 'error', description: 'errorRetrievingRecord' });
      } finally {
        setIsLoadingLastRecord(false);
      }
    };
    fetchLastRecord();
  }, [showErrorNotification]);

  const createRecord = useCallback(
    async ({ idWorkStation, idHeadquarter }) => {
      setIsCreating(true);
      try {
        await WorkStationRecordsService.createRecord({ idWorkStation, idHeadquarter });
      } catch (error) {
        const isWorkStationInUse = error?.response?.data?.message === WorkStationRecordsService.WORK_STATION_IN_USE;
        showErrorNotification({
          title: 'error',
          description: isWorkStationInUse ? 'workStationInUse' : 'errorCreatingRecord',
        });
        throw error;
      } finally {
        setIsCreating(false);
      }
    },
    [showErrorNotification],
  );

  return {
    lastRecord,
    isLoadingLastRecord,
    isCreating,
    createRecord,
  };
};

export { useWorkStationCheckin };
